// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoleDetailsCard-module__title___NQ2ZD{font-size:var(--size-6);color:var(--gray-90)}`, "",{"version":3,"sources":["webpack://./src/components/routeComponents/RoleManagement/ManageRole/RoleDetailsCard.module.scss"],"names":[],"mappings":"AAAA,uCACE,uBAAA,CACA,oBAAA","sourcesContent":[".title {\n  font-size: var(--size-6);\n  color: var(--gray-90);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `RoleDetailsCard-module__title___NQ2ZD`
};
export default ___CSS_LOADER_EXPORT___;
